import { useLazyQuery } from '@apollo/client';
import { GET_AUDIT_LOGS } from '@src/graphql/queries/auditLog';
import { DateRangeFilter } from '@src/types';
import { MessageType, useLocale } from 'pe-core-frontend';
import { useState } from 'react';
export var AuditLogEntity;
(function (AuditLogEntity) {
    AuditLogEntity["EMPLOYEE"] = "EMPLOYEE";
    AuditLogEntity["PROGRAM"] = "PROGRAM";
    AuditLogEntity["PAYMENT_REQUEST"] = "PAYMENT_REQUEST";
})(AuditLogEntity || (AuditLogEntity = {}));
export const useGetAuditLogs = ({ clientId }) => {
    const { t } = useLocale();
    const [searchSpec, setSearchSpec] = useState({
        entities: [AuditLogEntity.EMPLOYEE],
        dateRange: DateRangeFilter.PAST_7_DAYS,
    });
    const [messages, setMessages] = useState([]);
    const [auditLogsResponse, setAuditLogsResponse] = useState();
    const [fetch, { loading, error }] = useLazyQuery(GET_AUDIT_LOGS);
    const handleValidate = () => {
        const messages = [];
        if (!searchSpec.entities.length) {
            messages.push({
                type: MessageType.ERROR,
                value: t('At least one entity must be selected'),
            });
        }
        if (!searchSpec.uniqueId && !searchSpec.programNum && !searchSpec.paymentRequestNum) {
            messages.push({
                type: MessageType.ERROR,
                value: t('At least one search field must be filled'),
            });
        }
        setMessages(messages);
        return messages.length === 0;
    };
    const fetchAudits = async () => {
        if (!handleValidate()) {
            return;
        }
        const result = await fetch({ variables: { spec: { clientId, ...searchSpec } } });
        if (result.data?.getAuditLogs) {
            setAuditLogsResponse(result.data.getAuditLogs);
        }
    };
    return {
        auditLogsResponse,
        fetchAudits,
        messages,
        searchSpec,
        setSearchSpec,
        loading,
        error,
    };
};
